import type { IStyle, IStyleFunctionOrObject } from '@fluentui/react';
import type {
  IWizardActionBarStyleProps,
  IWizardActionBarStyles,
} from '@m365-admin/wizard';

export const buttonMargin = 8;

export const baseWABButtonSharedStyle: IStyle = {
  marginBottom: buttonMargin,
};

export const baseWABButtonMarginRightStyle: IStyle = {
  marginRight: buttonMargin / 2,
};

export const baseWABButtonMarginLeftStyle: IStyle = {
  marginLeft: buttonMargin / 2,
};

export const getWizardActionBarStyles = (
  props: IWizardActionBarStyleProps,
): IStyleFunctionOrObject<IWizardActionBarStyleProps, IWizardActionBarStyles> => {
  return {
    subComponentStyles: {
      back: (() => {
        return {
          root: [
            baseWABButtonSharedStyle,
            baseWABButtonMarginRightStyle,
            baseWABButtonMarginLeftStyle,
          ],
        };
      })(),
      main: (() => {
        return {
          root: [
            baseWABButtonSharedStyle,
            baseWABButtonMarginRightStyle,
            baseWABButtonMarginLeftStyle,
          ],
        };
      })(),
      saveclose: (() => {
        return { root: [baseWABButtonSharedStyle, baseWABButtonMarginRightStyle] }; // accounts for hover backplate
      })(),
      cancel: (() => {
        return { root: [baseWABButtonSharedStyle] }; // accounts for hover backplate
      })(),
    },
  };
};
